import { SkeletonItem } from '@fluentui/react-components';
import React from 'react';
import './TeachingUnitEntry.scss';

/**
 * Renders without wrapping the entry in a Fluent `<Skeleton>` parent. The
 * outer container is `.teachingUnitEntry` so multiple skeletons remain
 * direct siblings and the `& + & { border-top }` divider rule in
 * `TeachingUnitEntry.scss` matches between them. `<SkeletonItem>` uses the
 * same defaults (animation: 'wave', appearance: 'translucent') without an
 * explicit `<Skeleton>` ancestor.
 */
export const TeachingUnitEntrySkeleton: React.FC = () => {
  return (
    <div className="flex items-stretch teachingUnitEntry teachingUnitSkeleton">
      <div className="iconWrapperSkeleton">
        <SkeletonItem shape="circle" className="icon" />
      </div>
      <div className="teachingUnitEntryContent">
        <div className="teachingUnitEntryHeadline">
          <SkeletonItem className="headlineSkeleton" />
        </div>
        <div className="authorWrapper">
          <SkeletonItem shape="circle" className="authorAvatarSkeleton" />
          <SkeletonItem className="authorNameSkeleton" />
        </div>
        <div className="subheadline">
          <SkeletonItem className="subheadlineSkeleton" />
        </div>
      </div>
    </div>
  );
};
